/**
 * Server-trusted auth profile (roles, scopes, resource_mappings, etc.).
 * Lives only in memory — never persisted — and is overwritten by login response or GET /api/v2/auth/me.
 */

export const SERVER_PROFILE_UPDATED_EVENT = 'maiq-server-profile-updated';

let cached: Record<string, unknown> | null = null;

function cloneBody(body: Record<string, unknown>): Record<string, unknown> {
  return JSON.parse(JSON.stringify(body)) as Record<string, unknown>;
}

export function applyServerProfileFromApi(
  body: Record<string, unknown> | null | undefined,
): void {
  if (!body || typeof body !== 'object') {
    return;
  }
  const next = cloneBody(body);
  delete next.accesstoken;
  next.session = true;
  cached = next;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(SERVER_PROFILE_UPDATED_EVENT));
  }
}

/** Deep-cloned snapshot for callers; safe to mutate the returned object without affecting the cache. */
export function getServerProfile(): Record<string, unknown> | null {
  if (!cached) return null;
  return cloneBody(cached);
}

export function clearServerProfile(): void {
  cached = null;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(SERVER_PROFILE_UPDATED_EVENT));
  }
}
